import React from "react";
import {
  DivContentImgTurn,
  DivFlexColumContentTurn,
  DivLabelTurn,
} from "./TurnConfirmationSidebarStyles";
import ImgProcessingTalma from "../../images/processing_talma.png";
import LoadingTalmaClick from "../../images/loader-talmaclick.gif";
import { FC } from "react";

interface ITurnProcessingSidebar {
  labeHead?: string;
  labelBody?: string;
}
const TurnProcessingSidebar: FC<ITurnProcessingSidebar> = (props) => {
  const { labeHead, labelBody } = props;
  return (
    <DivFlexColumContentTurn>
      <DivContentImgTurn>
        <img src={ImgProcessingTalma} alt="" />
        <img
          src={LoadingTalmaClick}
          alt="icon-loading-talma"
          className="icon-loading"
        />
        <div>{labeHead ? labeHead : "Estamos validando"}</div>
        <DivLabelTurn>
          {labelBody
            ? labelBody
            : "Estamos validando si los volantes tienen restricciones"}
        </DivLabelTurn>
      </DivContentImgTurn>
    </DivFlexColumContentTurn>
  );
};

export default TurnProcessingSidebar;
